module.exports = __webpack_public_path__ + "img/buy.1f7b354d.png";